var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tinymce-editor", {
        attrs: {
          disabled: _vm.readonly,
          plugins: "paste autoresize table",
          init: _vm.tinyMCEInitParams
        },
        on: {
          onPaste: function($event) {
            return _vm.changeStyles(_vm.contextModel)
          }
        },
        model: {
          value: _vm.contextModel,
          callback: function($$v) {
            _vm.contextModel = $$v
          },
          expression: "contextModel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }